import {Controller} from 'stimulus';

export default class extends Controller {

  static targets = ['anker'];

  connect() {

    const ankerlist = document.getElementById('ankerlist');

    let u = '';
    const ankers=document.querySelectorAll('[data-ankerName]');

    // if(ankers.length > 0) document.getElementById('ankerlist').style.display = 'flex';
    if(ankers.length > 0) document.getElementById('ankerlistouter').classList.remove('hidden');

    [...ankers].forEach(
      btn => ankerlist.insertAdjacentHTML('beforeend', '<a data-action="click->anker#scroll" role="button" class="bg-primary px-3 py-1 d-block d-md-inline-block text-decoration-none p-3 mr-3 font-bold h5 text-white" href="#'+btn.getAttribute('id')+'">'+btn.getAttribute('data-ankerName')+'</a>')
    );
  }

  scroll(e) {
    // console.log(e.currentTarget.getAttribute('href').split('#')[1]);
    e.preventDefault();
    var id = e.currentTarget.getAttribute('href').split('#')[1]
    const t = document.getElementById(id);
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: t.offsetTop - 120
    });
  }
  trigger(e) {
    // document.getElementById('ankerlist').classList.toggle('max-h-0');
  }
}

